import { Component, Input } from '@angular/core';
import { WebPaths } from '@partner/shared/SharedConstants';
import { RequiringActionRowVm, ViewAllQuery, WaitBadgeTier } from '../../../../domain/model/executive-snapshot.model';

/** "Requiring your action": up to five longest-waiting applications with a wait badge, and "View all" to the list. */
@Component({
  selector: 'ifbp-requiring-action-list',
  templateUrl: './requiring-action-list.component.html',
  styleUrls: ['./requiring-action-list.component.scss'],
  standalone: false,
})
export class RequiringActionListComponent {
  @Input() rows: RequiringActionRowVm[] = [];
  @Input() showViewAll = false;
  @Input() viewAllQuery: ViewAllQuery;

  readonly WebPaths = WebPaths;
  readonly BadgeTier = WaitBadgeTier;

  trackByApplicationId(_index: number, row: RequiringActionRowVm): number {
    return row.applicationId;
  }
}
